import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react'
import * as React from 'react'
import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { PageInfoContextProvider } from './Components/Contexts/PageInfoContext'
import './index.css'
import reportWebVitals from './reportWebVitals'

const webVitals = (vitals: any) => {
  // console.log(`${vitals.name} - ${vitals.value}`)
  // console.log(`${vitals.name} - ${vitals.value/100}`)
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <BrowserRouter
      data-testid="browserRouter"
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <HelmetProvider>
        {/* Skip link at the top */}
        <a href="#main-content" className="absolute -top-10 left-0 focus:top-0 focus:z-50 focus:bg-neutral-40">
          Skip to main content
        </a>
        <ContentfulLivePreviewProvider
          data-testid="contentfulLivePreviewProvider"
          locale="en-US"
          enableInspectorMode={true}
          enableLiveUpdates
          debugMode={true}
          targetOrigin="https://app.contentful.com"
        >
          <PageInfoContextProvider>
            <App />
          </PageInfoContextProvider>
        </ContentfulLivePreviewProvider>
      </HelmetProvider>
    </BrowserRouter>
  </StrictMode>,
)

reportWebVitals(webVitals)
